<div class="content-body default-height">
    <!-- Breadcrumb  -->
    <app-breadcrumb [breadcrumb]="breadcrumbList" [addProperty]="'Back'" (addEvent)="goBackToList($event)"> </app-breadcrumb>
    <div class="container-fluid">
      <app-owner-overview (profileDetailsEvent)="getUserDetails($event)"></app-owner-overview>
  
      <div class="tab-content" id="tabContentMyProfileBottom">
        <div class="card">
          <div class="card-header-line">
          <div class="row">
            <div class="col-xl-6">
                <!-- <span class="badge badge-success strong border-0 m-3">Owner Bank Details</span> -->
            </div>
            <div class="col-xl-6">
              <a *ngIf="checkUserBankEdit" class="badge badge-success strong border-0 m-3 float-end c-pointer"
                href="javascript:void(0);" (click)="toggleBankDetails()">Edit Account
              </a>
              <!-- <a *ngIf="!ownerBankDetails?.bank_account_number && checkUserBankAdd" class="badge badge-success strong border-0 m-3 float-end c-pointer"
                href="javascript:void(0);" (click)="toggleBankDetails()">
                Add Account
              </a> -->
            </div>
        </div>
        </div>
        <div class="card-body">
        <div class="row">
            <div class="col-xl-4">
                <div class="card">
                  <!-- <div class="card-header py-3">
                    <h6 class="card-title">Selected Propertie</h6>                    
                  </div> -->
                  <div class="card-body">
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Account Holder Name </span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">	{{ownerBankDetails?.bank_account_name }}</span>
                      </div>
                    </div> 
                    <div class="row py-2">
                        <div class="col-6">
                          <span class="fs-13">Account Number</span>
                        </div>
                        <div class="col-6">
                          <span class="fs-13 text-secondary fw-semibold">{{ownerBankDetails?.bank_account_number }}</span>
                        </div>
                      </div>
                      <div class="row py-2">
                        <div class="col-6">
                          <span class="fs-13">Bank Name</span>
                        </div>
                        <div class="col-6">
                          <span class="fs-13 text-secondary fw-semibold">{{ownerBankDetails?.bank_name }}</span>
                        </div>
                      </div>
                      <div class="row py-2">
                        <div class="col-6">
                          <span class="fs-13">Account Type</span>
                        </div>
                        <div class="col-6">
                          <span class="fs-13 text-secondary fw-semibold">{{ownerBankDetails?.bank_account_type }}</span>
                        </div>
                      </div>
                      <div class="row py-2">
                        <div class="col-6">
                          <span class="fs-13">IFSC CODE</span>
                        </div>
                        <div class="col-6">
                          <span class="fs-13 text-secondary fw-semibold">{{ownerBankDetails?.bank_ifsc_code }}</span>
                        </div>
                      </div> 
                      <div class="row py-2">
                        <div class="col-6">
                          <span class="fs-13">Branch Name</span>
                        </div>
                        <div class="col-6">
                          <span class="fs-13 text-secondary fw-semibold">{{ownerBankDetails?.bank_branch }}</span>
                        </div>
                      </div>
                      <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Contact Number</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{ownerBankDetails?.bank_phone }}</span>
                      </div>
                    </div>                 
                    
                                        
                  </div>
                </div>
              </div>
              </div>
        </div>

        </div>
      </div>
    </div>
</div>

<div #addEditBankButton class="offcanvas offcanvas-end customeoff {{ bank_details ? 'show':''}}" tabindex="-1" id="bank_details" data-bs-backdrop="static">
    <div class="offcanvas-header">
    <h5 class="modal-title" id="#gridSystemModal">Add Bank Account</h5>
      <button type="button" class="btn-close" (click)="cancel()">
          <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
    <div class="offcanvas-body">
      <div class="container-fluid" >
      <form [formGroup]="bankForm" (ngSubmit)="onSubmit()" autocomplete="off"> 
        <div class="row">
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-1" class="form-label">Account Holder Name<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="ABC" formControlName="bank_account_name">
            <div *ngIf="bankForm?.get('bank_account_name')?.invalid && bankForm?.get('bank_account_name')?.touched" class="required">
                Account holder name is required
          </div>
        </div>
          <div class="col-xl-6 mb-3">
              <label for="exampleFormControlInput1-1" class="form-label">Account Number<span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="32145469870" formControlName="bank_account_number">
              <div *ngIf="bankForm?.get('bank_account_number')?.invalid && bankForm?.get('bank_account_number')?.touched" class="required">
                Account number is required
            </div>
          </div>	
          <div class="col-xl-6 mb-3">
              <label for="exampleFormControlInput1-2" class="form-label">Account Type<span class="text-danger">*</span></label>
              <select class="form-select" formControlName="bank_account_type">
                <option  data-display="Select" value="null" selected>Please select</option>
                <option value="current">Current</option>                          
                <option value="nri">NRI</option>
                <option value="nro">NRO</option>
                <option value="nre">NRE</option>
            </select>
              <div *ngIf="bankForm?.get('bank_account_type')?.invalid && bankForm?.get('bank_account_type')?.touched" class="required">
                Account type is required
            </div>
          </div>	
          <div class="col-xl-6 mb-3">
              <label for="exampleFormControlInput1-3" class="form-label">Bank Name<span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="HDFC" formControlName="bank_name">
              <div *ngIf="bankForm?.get('bank_name')?.invalid && bankForm?.get('bank_name')?.touched" class="required">
                Bank name is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
              <label for="exampleFormControlInput1-4" class="form-label">IFSC Code<span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="HDFC0003210" formControlName="bank_ifsc_code">
              <div *ngIf="bankForm?.get('bank_ifsc_code')?.invalid && bankForm?.get('bank_ifsc_code')?.touched" class="required">
                IFSC code is required
            </div>                                            
          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Branch Name<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="TS" formControlName="bank_branch">  
            <div *ngIf="bankForm?.get('bank_branch')?.invalid && bankForm?.get('bank_branch')?.touched" class="required">
                Branch name is required
            </div>                                            
          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Bank Contact Number</label>
            <input type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="1234567890" formControlName="bank_phone">          
          </div>        
        <!-- <div class="col-xl-6 mb-3 display">
          <label for="exampleFormControlInput1-3" class="form-label">Address Line2</label>
          <input type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="KDD" formControlName="address_line2">                                                   
        </div>        
        <div class="col-xl-6 mb-3 display">
          <label for="exampleFormControlInput1-3" class="form-label">Pincode</label>
          <input type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="987456" formControlName="pincode">                                              
        </div>   -->
        
      </div>
              <div>
                  <button class="btn btn-primary ms-1 me-3" type="submit" [disabled]="bankForm.invalid || loadingService.isLoading()">Save</button>
                  <button class="btn btn-danger lightme-1" type="button" (click)="cancel()">Cancel</button>
              </div>
      </form>
        </div>
    </div>
  </div>		
  @if(bank_details){
    <div class="offcanvas-backdrop fade show" (click)="toggleBankDetails()"></div>
  }

